import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import DashboardHeading from '../commonFiles/DashboardHeading';
import ScheduleConsultationPopup from './ScheduleConsultationPopup';
import ChangeServicePersonPopup from './ChangeServicePersonPopup';
class ScheduleConsultation extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:'',
      open_popup:'',
      open_service_person:'',
    };
  }

  view_table_row(table_data){
    let cutThis = this;
    var all_table_row = [];
    var nu = 1;
    for(var data in table_data){
      var id                  = table_data[data]['id'];
      var subject_matter      = table_data[data]['subject_matter'];
      var added_date          = table_data[data]['added_date'];
      var write_flag          = table_data[data]['write_flag'];
      var action_flag         = table_data[data]['action_flag'];
      var first_name          = table_data[data]['first_name'];
      var last_name           = table_data[data]['last_name'];
      var email               = table_data[data]['email'];
      var mobile_no           = table_data[data]['mobile_no'];
      var service_person_id   = table_data[data]['service_person'];
      var service_person      = table_data[data]['service_person_name'];
      var schedule_date_time  = table_data[data]['schedule_date']+" "+table_data[data]['schedule_time'];
      var status              = ['Inactive','Active','End'];

      var view_icon           = '';
      var change_service_per_icon = '';
      var add_info_icon = '';

      if(action_flag!=2){

        view_icon = <span className="pointer" onClick={cutThis.open_view_popup.bind(cutThis,id)} title="View"><i class="fa fa-eye me-1"></i></span>;
        change_service_per_icon = <span className="pointer" onClick={cutThis.open_change_service_person_popup.bind(cutThis,id,service_person_id)} title="Change Service Person"><i class="fa fa-users-cog me-1"></i></span>;
        //if(action_flag==0){view_icon = <span className="pointer" onClick={cutThis.active_view_popup.bind(cutThis,id)} title="Active"><i class="fa fa-check-square" aria-hidden="true"></i></span>;}

      }

      all_table_row.push(
        <tr id={nu}>
        <th scope="row">{nu}</th>
        <td>{subject_matter}</td>
        <td>{first_name+" "+last_name}</td>
        <td>{email}</td>
        <td>{mobile_no}</td>
        <td>{schedule_date_time}</td>
        <td>{service_person}</td>
        <td>{added_date}</td>
        <td>{status[action_flag]}</td>
        <td>{view_icon}</td>
        <td>{change_service_per_icon}</td>
        <td>{add_info_icon}</td>
        </tr>
      );
      nu++;
    }
    cutThis.setState({all_table_row});
  }

active_view_popup(id){

}
open_view_popup(id){
  var open_popup = <ScheduleConsultationPopup id={id} close_popup_view={this.close_popup.bind(this)}/>;
  this.setState({open_popup});
  setTimeout(function (){window.model_show();},100);
}
close_popup(){
  window.model_hide();
  var open_popup = '';
  this.setState({open_popup});
  this.getFreeConsultation();
}



open_change_service_person_popup(id,service_person_id){
  var open_service_person = <ChangeServicePersonPopup id={id} service_person_id={service_person_id} close_popup_view={this.close_service_person_popup.bind(this)}/>;
  this.setState({open_service_person});
  setTimeout(function (){window.model_show();},100);
}



close_service_person_popup(){
  window.model_hide();
  var open_service_person = '';
  this.setState({open_service_person});
  this.getFreeConsultation();
}


componentDidMount(){
  this.getFreeConsultation();
}
getFreeConsultation(){
    let cutThis = this;
    var web_token = $('#web_token').val();
     var body = new FormData();
     body.append('web_token',web_token);
     body.append('function','get_schedule_consultation_data');
     var url      = '';
     if(window.location.host ==="localhost:3000"){
       url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
     }else{
       url = "/php/admin_free_consultation_url.php";
     }
     axios({
          method: 'POST',
          url: url,
          data: body
      })
      .then(function (res) {
        var data = res.data;
        if(data['code']==1){
          cutThis.view_table_row(data['msg']);
        }else{
          //window.location.href = '/';
        }

      })
      .catch(function (error) {
          console.log(error);
      });
}

  render() {
    return (
        <>
        <DashboardHeading title="Schedule Consultation"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Schedule Consultation</h3>
                <div className="row g-4">
                <table class="table">
                <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Subject Matter</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Mobile</th>
                <th scope="col">Schedule Date & Time</th>
                <th scope="col">Service Person</th>
                <th scope="col">Added Date</th>
                <th scope="col">Status</th>
                <th scope="col" colSpan="3">Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.all_table_row}
                </tbody>
                </table>

            </div>
        </div>
        {this.state.open_popup}
        {this.state.open_service_person}
        </>
    );
  }
}

export default ScheduleConsultation;
